var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c(
      "div",
      { staticClass: "box" },
      [
        _c("h1", { staticClass: "title is-4" }, [
          _vm._v(_vm._s(_vm.constants.STRINGS.TITLES.SEARCH_FILTERS)),
        ]),
        _vm._v(" "),
        _c("section", [
          _vm.hasLyrisRole
            ? _c(
                "div",
                { staticClass: "field mb-0" },
                [
                  _c(
                    "div",
                    { staticClass: "field" },
                    [
                      _c("label", { staticClass: "label" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.constants.STRINGS.SUBTITLES
                                .FILTERS_OTROS_DOCUMENTOS.PER_ORGANIZATION
                            ) +
                            "\n            "
                        ),
                        _c(
                          "span",
                          { staticClass: "is-pulled-right" },
                          [
                            _c(
                              "b-tooltip",
                              {
                                attrs: {
                                  label: "Opción para Lyris",
                                  position: "is-left",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-star is-pulled-right",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.selectedOrganization
                        ? _c(
                            "b-autocomplete",
                            {
                              staticClass: "input-field",
                              attrs: {
                                data: _vm.searchOrganizationResults,
                                loading: _vm.isFetching,
                                placeholder:
                                  _vm.constants.STRINGS.PLACEHOLDERS
                                    .WRITE_NAME_OR_ID,
                                field: "razon_social",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.getOrganizationsWithInstalledModule(
                                    _vm.constants.STRINGS.MODULES.NOTIFICACIONES
                                      .ID
                                  )
                                },
                                select: (option) =>
                                  _vm.selectOrganization(option),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c("i", {
                                          staticClass: "fas fa-building",
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(props.option.id) +
                                            " - " +
                                            _vm._s(
                                              props.option.razon_social.toUpperCase()
                                            ) +
                                            "\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "is-size-7" },
                                          [
                                            _vm._v(
                                              _vm._s(props.option.slug) +
                                                " - " +
                                                _vm._s(props.option.cuit)
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1271691841
                              ),
                              model: {
                                value: _vm.organizationInput,
                                callback: function ($$v) {
                                  _vm.organizationInput = $$v
                                },
                                expression: "organizationInput",
                              },
                            },
                            [
                              _vm._v(" "),
                              _c("template", { slot: "empty" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.constants.STRINGS.ERRORS.NO_RESULTS_FOR
                                  ) +
                                    " " +
                                    _vm._s(_vm.organizationInput)
                                ),
                              ]),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-field",
                    { staticClass: "mb-5" },
                    [
                      _vm.selectedOrganization
                        ? _c(
                            "b-tag",
                            {
                              attrs: {
                                icon: "fas fa-building",
                                size: "is-medium",
                                attached: "",
                                "aria-close-label": "Close tag",
                                closable: "",
                              },
                              on: {
                                close: function ($event) {
                                  return _vm.unselectOrganization()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.selectedOrganization.razon_social.toUpperCase()
                                  ) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "b-field",
          {
            staticClass: "mb-0",
            attrs: {
              label:
                _vm.constants.STRINGS.SUBTITLES.FILTERS_OTROS_DOCUMENTOS
                  .FOR_DOCUMENT_NAME,
            },
          },
          [
            _c("b-input", {
              attrs: {
                placeholder:
                  _vm.constants.STRINGS.PLACEHOLDERS.WRITE_DOCUMENT_NAME,
                maxlength: "30",
              },
              on: { keyup: _vm.updateList },
              model: {
                value: _vm.documents.inputName,
                callback: function ($$v) {
                  _vm.$set(_vm.documents, "inputName", $$v)
                },
                expression: "documents.inputName",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.hasLyrisRole || (_vm.hasOtrosAdminRole && _vm.hasOtrosUserRole)
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showOnlyMyDocuments,
                    expression: "showOnlyMyDocuments",
                  },
                ],
                staticClass: "field",
              },
              [
                _c(
                  "b-checkbox",
                  {
                    model: {
                      value: _vm.onlyMyDocuments,
                      callback: function ($$v) {
                        _vm.onlyMyDocuments = $$v
                      },
                      expression: "onlyMyDocuments",
                    },
                  },
                  [
                    _c("label", { staticClass: "label" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.constants.STRINGS.SUBTITLES
                              .FILTERS_OTROS_DOCUMENTOS.SEE_ONLY_MY_DOCUMENTS
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasLyrisRole || _vm.hasOtrosAdminRole
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showSearchUser,
                    expression: "showSearchUser",
                  },
                ],
                staticClass: "field mb-0",
              },
              [
                _c("label", { staticClass: "label" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.constants.STRINGS.SUBTITLES.FILTERS_OTROS_DOCUMENTOS
                          .FOR_EMPLOYEE
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                !_vm.users.selected
                  ? _c(
                      "b-autocomplete",
                      {
                        staticClass: "input-field",
                        attrs: {
                          data: _vm.users.searchResults,
                          placeholder:
                            _vm.constants.STRINGS.PLACEHOLDERS
                              .WRITE_NAME_OR_SURNAME,
                          field: "userSurname",
                          loading: _vm.isFetching,
                          maxlength: "30",
                        },
                        on: {
                          input: _vm.getUser,
                          select: (option) => this.selectUser(option),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c("i", { staticClass: "fas fa-user" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        props.option.apellido.toUpperCase()
                                      ) +
                                      ", " +
                                      _vm._s(props.option.nombre) +
                                      "\n          "
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "is-size-7" }, [
                                    _vm._v(
                                      _vm._s(props.option.cuil) +
                                        " - " +
                                        _vm._s(props.option.email)
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1470996560
                        ),
                        model: {
                          value: _vm.users.input,
                          callback: function ($$v) {
                            _vm.$set(_vm.users, "input", $$v)
                          },
                          expression: "users.input",
                        },
                      },
                      [
                        _vm._v(" "),
                        _c("template", { slot: "empty" }, [
                          _vm._v(
                            _vm._s(
                              _vm.constants.STRINGS.ERRORS.NO_RESULTS_FOR
                            ) +
                              " " +
                              _vm._s(_vm.users.input)
                          ),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "b-field",
          { staticClass: "my-2" },
          [
            _vm.users.selected
              ? _c(
                  "b-tag",
                  {
                    attrs: {
                      icon: "fas fa-user",
                      size: "is-medium",
                      attached: "",
                      "aria-close-label": "Close tag",
                      closable: "",
                    },
                    on: {
                      close: function ($event) {
                        return _vm.clearUserSection()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.users.selected.apellido.toUpperCase()) +
                        ", " +
                        _vm._s(_vm.users.selected.nombre) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.hasLyrisRole || _vm.hasOtrosAdminRole
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showSearchArea,
                    expression: "showSearchArea",
                  },
                ],
                staticClass: "field mb-0",
              },
              [
                _c("label", { staticClass: "label" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.constants.STRINGS.SUBTITLES.FILTERS_OTROS_DOCUMENTOS
                          .FOR_AREA
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                !_vm.areas.selected
                  ? _c(
                      "b-autocomplete",
                      {
                        staticClass: "input-field",
                        attrs: {
                          data: _vm.areas.searchResults,
                          placeholder:
                            _vm.constants.STRINGS.PLACEHOLDERS.WRITE_NAME,
                          field: "areaName",
                          loading: _vm.isFetching,
                          maxlength: "30",
                        },
                        on: {
                          input: _vm.getAreas,
                          select: (option) => this.selectArea(option),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c("i", { staticClass: "fas fa-tag" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(props.option.id) +
                                      " - " +
                                      _vm._s(props.option.nombre) +
                                      "\n          "
                                  ),
                                  _c("br"),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3008951276
                        ),
                        model: {
                          value: _vm.areas.input,
                          callback: function ($$v) {
                            _vm.$set(_vm.areas, "input", $$v)
                          },
                          expression: "areas.input",
                        },
                      },
                      [
                        _vm._v(" "),
                        _c("template", { slot: "empty" }, [
                          _vm._v(
                            _vm._s(
                              _vm.constants.STRINGS.ERRORS.NO_RESULTS_FOR
                            ) +
                              " " +
                              _vm._s(_vm.areas.input)
                          ),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "b-field",
          { staticClass: "my-2" },
          [
            _vm.areas.selected
              ? _c(
                  "b-tag",
                  {
                    attrs: {
                      icon: "fas fa-tag",
                      size: "is-medium",
                      attached: "",
                      "aria-close-label": "Close tag",
                      closable: "",
                    },
                    on: {
                      close: function ($event) {
                        return _vm.clearAreaSection()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.areas.selected.id) +
                        " - " +
                        _vm._s(_vm.areas.selected.nombre) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.hasLyrisRole || _vm.hasOtrosAdminRole
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showAllOrganization,
                    expression: "showAllOrganization",
                  },
                ],
                staticClass: "field",
              },
              [
                _c(
                  "b-checkbox",
                  {
                    model: {
                      value: _vm.allOrganization,
                      callback: function ($$v) {
                        _vm.allOrganization = $$v
                      },
                      expression: "allOrganization",
                    },
                  },
                  [
                    _c("label", { staticClass: "label" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.constants.STRINGS.SUBTITLES
                              .FILTERS_OTROS_DOCUMENTOS.FOR_ALL_ORGANIZATION
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.constants.STRINGS.SUBTITLES.FILTERS_OTROS_DOCUMENTOS
                    .FOR_DATE
                ) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "help" }, [
            _vm._v(
              _vm._s(
                _vm.constants.STRINGS.LABELS
                  .BLANK_FIELD_REPRESENTS_ANY_DAY_MONTH_OR_YEAR
              )
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field is-horizontal is-mobile" }, [
          _c("div", { staticClass: "field-body" }, [
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.date.year,
                      expression: "date.year",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "min:4|max:4|min_value:1920|numeric",
                      expression: "'min:4|max:4|min_value:1920|numeric'",
                    },
                  ],
                  staticClass: "input has-text-centered",
                  class: { "is-danger": _vm.errors.has("año") },
                  attrs: {
                    name: "año",
                    placeholder: _vm.constants.STRINGS.PLACEHOLDERS.YEAR,
                  },
                  domProps: { value: _vm.date.year },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.date, "year", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.date.month,
                      expression: "date.month",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "max:2|min_value:1|max_value:12|numeric",
                      expression: "'max:2|min_value:1|max_value:12|numeric'",
                    },
                  ],
                  staticClass: "input has-text-centered",
                  class: { "is-danger": _vm.errors.has("mes") },
                  attrs: {
                    name: "mes",
                    disabled: _vm.date.year == "" || _vm.errors.has("año"),
                    placeholder: _vm.constants.STRINGS.PLACEHOLDERS.MONTH,
                  },
                  domProps: { value: _vm.date.month },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.date, "month", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.date.day,
                      expression: "date.day",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "max:2|min_value:1|max_value:31|numeric",
                      expression: "'max:2|min_value:1|max_value:31|numeric'",
                    },
                  ],
                  staticClass: "input has-text-centered",
                  class: { "is-danger": _vm.errors.has("dia") },
                  attrs: {
                    name: "dia",
                    disabled: _vm.date.month == "" || _vm.errors.has("mes"),
                    placeholder: _vm.constants.STRINGS.PLACEHOLDERS.DAY,
                  },
                  domProps: { value: _vm.date.day },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.date, "day", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.errors.has("año")
          ? _c("span", { staticClass: "help is-danger" }, [
              _vm._v(_vm._s(_vm.errors.first("año"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.errors.has("mes")
          ? _c("span", { staticClass: "help is-danger" }, [
              _vm._v(_vm._s(_vm.errors.first("mes"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.errors.has("dia")
          ? _c("span", { staticClass: "help is-danger" }, [
              _vm._v(_vm._s(_vm.errors.first("dia"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [
            _vm._v(
              _vm._s(
                _vm.constants.STRINGS.SUBTITLES.FILTERS_OTROS_DOCUMENTOS
                  .FOR_DOCUMENT_TYPE
              )
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _vm.documents.loadingTypes
              ? _c("input", {
                  staticClass: "input",
                  attrs: { type: "text" },
                  domProps: {
                    value:
                      _vm.constants.STRINGS.LOADING.LOADING_TEXT_WITH_SLASHES,
                  },
                })
              : _c("div", { staticClass: "select is-fullwidth" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.documents.selectedType,
                          expression: "documents.selectedType",
                        },
                      ],
                      attrs: { name: "" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.documents,
                            "selectedType",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v(
                          _vm._s(_vm.constants.STRINGS.DOCUMENTS.TYPES.ANY_TYPE)
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.documents.types, function (type, i) {
                        return _c(
                          "option",
                          { key: i, domProps: { value: type.id } },
                          [_vm._v(_vm._s(type.nombre))]
                        )
                      }),
                    ],
                    2
                  ),
                ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.hasLyrisRole || _vm.hasOtrosAdminRole
          ? _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label", attrs: { for: "" } }, [
                _vm._v(
                  _vm._s(
                    _vm.constants.STRINGS.SUBTITLES.FILTERS_OTROS_DOCUMENTOS
                      .FOR_DOCUMENT_STATUS
                  )
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "control" }, [
                _c("div", { staticClass: "select is-fullwidth" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.documents.selectedStatus,
                          expression: "documents.selectedStatus",
                        },
                      ],
                      attrs: { name: "" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.documents,
                            "selectedStatus",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    _vm._l(_vm.documents.statuses, function (status, i) {
                      return _c(
                        "option",
                        {
                          key: i,
                          domProps: { value: i === 0 ? null : status },
                        },
                        [_vm._v(_vm._s(status))]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label", attrs: { for: "" } }, [
            _vm._v(_vm._s(this.getTextDependingRolesAssigned)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c("div", { staticClass: "select is-fullwidth" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.documents.selectedSignStatus,
                      expression: "documents.selectedSignStatus",
                    },
                  ],
                  attrs: { name: "" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.documents,
                        "selectedSignStatus",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                _vm._l(_vm.documents.signStatuses, function (signStatus, i) {
                  return _c(
                    "option",
                    {
                      key: i,
                      domProps: { value: i === 0 ? null : signStatus },
                    },
                    [_vm._v(_vm._s(signStatus))]
                  )
                }),
                0
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "buttons mt-4" }, [
          _c(
            "button",
            { staticClass: "button is-light", on: { click: _vm.setDefaults } },
            [
              _c("i", { staticClass: "fas fa-broom" }),
              _vm._v(" " + _vm._s(_vm.constants.STRINGS.BUTTONS.CLEAN_FILTERS)),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button is-primary",
              attrs: { disabled: _vm.errors.count() > 0 },
              on: { click: _vm.updateList },
            },
            [
              _c("i", { staticClass: "fas fa-search" }),
              _vm._v(" " + _vm._s(_vm.constants.STRINGS.BUTTONS.SEARCH)),
            ]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }